module.exports = __webpack_public_path__ + "../static/img/sv.60c25b9e.png";